import { IDR } from '@/libs/currency'
import { defaultThStyle } from '../../config'

export const optionDateRangeLowMovingStock = [
  {
    value: 'this_month',
    text: 'Bulan Ini',
  },
  {
    value: 'last_month',
    text: 'Bulan Lalu',
  },
  {
    value: 'two_month_ago',
    text: '2 Bulan Lalu',
  },
]

const defaultLowMovingStockClass = {
  tdClass: 'font-[400] text-[#333333] !p-[12px_15px] !text-[12px]',
  class: '!capitalize !text-[#333333]',
}

const defaultLowMovingStockThStyle = {
  ...defaultThStyle,
  fontSize: '12px',
  fontWeight: '600',
  padding: '12px 16px',
}

export const lowMovingStockFields = [
  {
    key: 'partner_name',
    label: 'Nama Partner',
    thStyle: {
      ...defaultLowMovingStockThStyle,
      minWidth: '300px',
    },
    ...defaultLowMovingStockClass,
  },
  {
    key: 'warehouse',
    label: 'Mitra Gudang',
    thStyle: {
      ...defaultLowMovingStockThStyle,
      minWidth: '300px',
    },
    ...defaultLowMovingStockClass,
  },
  {
    key: 'partner_contact',
    label: 'Kontak',
    thStyle: {
      ...defaultLowMovingStockThStyle,
      minWidth: '213px',
    },
    ...defaultLowMovingStockClass,
  },
  {
    key: 'unsold_quantity',
    label: 'Jumlah Barang',
    thStyle: {
      ...defaultLowMovingStockThStyle,
      minWidth: '190px',
    },
    ...defaultLowMovingStockClass,
  },
  {
    key: 'low_moving_cost',
    label: 'Biaya Low Moving',
    thStyle: {
      ...defaultLowMovingStockThStyle,
      minWidth: '180px',
    },
    ...defaultLowMovingStockClass,
    formatter: value => IDR(value).replace('.', ''),
  },
]
